import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { ClientGrantsCreateModalProps, CreateOrganizationClientGrantApi } from "../../../services/types";
import ClientGrantCreatedModal from "./ClientGrantCreatedModal";
import ClientGrantFormModal from "./ClientGrantFormModal";

const ClientGrantsCreateOrUpdateModal = (props: ClientGrantsCreateModalProps) => {
	const form = useForm<CreateOrganizationClientGrantApi>({
		defaultValues: props.defaultValues,
	});
	const { onHide } = props;
	const secretId = form.watch("secret_id");

	return (
		<Modal onHide={onHide} show>
			{secretId ? (
				<ClientGrantCreatedModal watch={form.watch} />
			) : (
				<ClientGrantFormModal {...props} form={form} />
			)}
		</Modal>
	);
};

export default ClientGrantsCreateOrUpdateModal;
